<template>
  <div :class="`sidebar ${foldAside ? 'fold' : 'unfold'}`">
    <div class="sidebar-wrapper">
      <div class="sidebar-header">
        <div class="sidebar-header-logo">
          <img src="@/assets/images/a-tupianyihuifu-58.png" alt="">
        </div>
        <p class="sidebar-header-title">
          <span v-if="!foldAside">天天有保业务系统</span>
        </p>
      </div>
      <div class="sidebar-content">
        <el-menu
          class="sidebar-body"
          :default-active="$route.path"
          text-color="#fff"
          background-color="#333744"
          :unique-opened="true"
          :collapse="foldAside"
          :collapse-transition="false" >
          <SidebarItem
            v-for="route in menuList"
            :key="route.id"
            :item="route"
            :base-path="route.path"
          ></SidebarItem>
        </el-menu>
      </div>
    </div>
  </div>
</template>
<script>
import SidebarItem from "./SidebarItem.vue";
import {mapState} from "vuex";
import { getQueryMenus } from "@/api/interface/global";
import { eleScrollIntoView } from '@/utils/dom';

export default {
  name: "Sidebar",
  components: {
    SidebarItem,
  },
  data() {
    return {
      menu: undefined,
      isCollapse: false,
    };
  },
  computed: {
    ...mapState('global', ["foldAside", 'wxGzhUnRead']),
    menuList(){
      const {menu} = this;
      if (!(Array.isArray(menu) && menu.length > 0)) return [];
      return this.deepMenu(menu);
    }
  },
  mounted() {
    this.clear();
    this.getQueryMenus();
    this.getWxGzhUnRead();
    this.timer = setInterval(() => {this.getWxGzhUnRead()}, 30000);
  },
  beforeDestroy(){
    this.clear();
  },
  methods: {
    getQueryMenus() {
      getQueryMenus({}).then(res => {
        if (res && Array.isArray(res.data)){
          localStorage.setItem("menuList", JSON.stringify(res.data))
          this.menu = res.data;
          this.scollIntoView();
        }
      })
    },
    deepMenu(arr){
      const wxGzhUnRead = this.wxGzhUnRead || 0;
      let result = [];
      if (!(Array.isArray(arr) && arr.length > 0)) return result;

      arr.map(item => {
        const {childList, ...temp} = item;
        temp.path = item.url;
        temp.meta = {
          title: item.name,
          icon: item.icon,
          alwaysShow: true,
        };
        temp.name = item.code;
        if (item.name === '公众号消息') temp.wxGzhUnRead = wxGzhUnRead;

        if (Array.isArray(childList) && childList.length > 0){
          temp.children = this.deepMenu(childList);
        }
        result.push(temp);
      })
      
      return result;
    },
    getWxGzhUnRead(){
      this.$store.dispatch('global/getWxGzhUnRead');
    },
    clear(){
      if (this.timer) clearInterval(this.timer);
    },
    scollIntoView(){
      setTimeout(() => {
        const activeLi = document.querySelector('.hn-menu-item.is-active');
        eleScrollIntoView(activeLi);
      }, 500)
    }
  },
};
</script>

<style lang="scss" scoped>
.sidebar {
  width: 260px;
  flex-shrink: 0;
  height: 100%;
  text-align: inherit;
  background: rgb(50, 54, 67, 0.8);
  overflow: auto;
  &-header{
    padding-top: 15px;
    line-height: 30px;
    font-weight: 600;
    font-size: 20px;
    color: #fff;
    text-align: center;
    &-logo {
      font-size: 0;
      img{
        height: 40px;
        vertical-align: top;
      }
    }
  }
  &-body{
    padding-bottom: 30px;
    text-align: initial;
    border-right: 0;
    background: transparent !important;
    ::v-deep {
      .el-menu{
        background: transparent !important;
      }
    }
  }

  // 折叠样式
  &.fold{
    width: 64px;
    &::v-deep{
      .el-menu--collapse {
        .el-submenu__title {
          margin-left: 0;
          margin-right: 0;
          justify-content: center;
        }
      }
    }
  }
}
</style>
